const patient_bus = {
  openModalTwin: false,
  twinFor: '', // siblings, son_daughter, uncle_aunts
  twinParentRkey: ''
}

export default {
  patient_bus
}